export enum GovernmentIdentificationType {
    BSN = 'BSN',
    VAT_ID = 'VAT ID',
    ITIN = 'ITIN',
    RESALE = 'RESALE',
    CORP_ID = 'CORP-ID',
    CORP_REG = 'CORP-REG',
    PERSONAL_ID = 'PERSONAL ID',
    TAX_ID = 'TAX ID'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/government-identification-type.enum.ts